import { HeroBlock } from '../types/content';

export const executiveHeroBlocks: HeroBlock[] = [
  {
    title: 'Executive Overview',
    description:
      'Formal clarification of progressive executive leadership, capital management authority, and enterprise-wide scope across Fortune 500 utility operations.'
  },
  {
    title: 'Value Proposition Summary',
    description:
      'Translating emerging clean-tech opportunities into scalable revenue models while managing regulatory, grid, and customer requirements.'
  },
  {
    title: 'Strategic Leadership Philosophy',
    description:
      'Grounded in trust, empowerment, curiosity, and disciplined execution to create long-term enterprise and customer value.'
  }
];
